import { render, staticRenderFns } from "./print-ticket.vue?vue&type=template&id=2f3cbdc2&scoped=true&"
import script from "./print-ticket.vue?vue&type=script&lang=js&"
export * from "./print-ticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3cbdc2",
  null
  
)

export default component.exports